<template>
    <div class="">
        <div class="">
            <slot name="tablist" :showTab="showTab"></slot>
        </div>
        <slot name="tabcontent" :showTab="showTab">
            <div class="tab-content">
            </div>
        </slot>
    </div>
</template>

<script>
    export default {
        mounted() {},
        methods: {
            showTab( evt ) {
                const selector = evt.target.attributes.href.value;
                $( selector ).tab('show');
            }
        }
    }
</script>
